export default __webpack_public_path__ + "static/media/basic-push-pin-8.662983fe.png";